module.exports = __webpack_public_path__ + "static/media/background-dsprivate.4c4d5d12.jpg";